/**
 * PURPOSE: Owns every APPLICATION_LOAD_ERROR dispatch in Sales Check-In — the fatal bootstrap
 * failures that leave the user on <BootstrapError /> instead of the app.
 *
 * The guard chains themselves live in `constants/applicationLoadErrorGuards`; this file maps each
 * chain to the action that makes its input available and dispatches the first match.
 */

// libraries
import { applicationLoadErrorActionTypes, bootstrapActionTypes, initActionTypes } from '@makemydeal/dr-shared-store';

// consts/enums
import { POST_INIT_GUARD_RULES, PRE_REQUEST_GUARD_RULES } from '../constants/applicationLoadErrorGuards';

// interfaces/types
import type { LoadErrorGuard } from '../types/applicationLoadError.types';

const guardsForAction = (actionType: string): LoadErrorGuard[] | undefined => {
    switch (actionType) {
        case bootstrapActionTypes.BOOTSTRAP_INITIAL_LOAD:
            return PRE_REQUEST_GUARD_RULES;
        case initActionTypes.INIT_PENCIL_SUCCESS:
            return POST_INIT_GUARD_RULES;
        default:
            return undefined;
    }
};

export const applicationLoadErrorMiddleware = (store: any) => (next: any) => (action: any) => {
    next(action);

    const guards = guardsForAction(action.type);
    if (!guards) return;

    // getState() after next(action) — post-init guards read what the reducers just wrote.
    const state = store.getState();
    const failed = guards.find((guard) => guard.when(state));
    if (!failed) return;

    store.dispatch({
        type: applicationLoadErrorActionTypes.APPLICATION_LOAD_ERROR,
        payload: { message: failed.message(state) }
    });
};
